"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sleep;

function sleep(interval) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, interval);
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9zbGVlcC5qcyJdLCJuYW1lcyI6WyJzbGVlcCIsImludGVydmFsIiwiUHJvbWlzZSIsInJlc29sdmUiLCJzZXRUaW1lb3V0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQWUsU0FBU0EsS0FBVCxDQUFlQyxRQUFmLEVBQXlCO0FBQ3RDLFNBQU8sSUFBSUMsT0FBSixDQUFZLFVBQUFDLE9BQU87QUFBQSxXQUFJQyxVQUFVLENBQUNELE9BQUQsRUFBVUYsUUFBVixDQUFkO0FBQUEsR0FBbkIsQ0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2xlZXAoaW50ZXJ2YWwpIHtcbiAgcmV0dXJuIG5ldyBQcm9taXNlKHJlc29sdmUgPT4gc2V0VGltZW91dChyZXNvbHZlLCBpbnRlcnZhbCkpO1xufVxuIl19